import { render } from "./Account.vue?vue&type=template&id=245e2351"
import script from "./Account.vue?vue&type=script&lang=js"
export * from "./Account.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/Eu529ade/0/shiawasedo/summus-beautylab-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__